import tw, { css } from 'twin.macro'

export default css`
  body {
    ${tw`font-body text-indigoBlue dark:text-white`}
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    ${tw`mb-4 leading-tight`}
  }
  p {
    ${tw`mb-4 leading-snug`}
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  div,
  section {
    ${tw`scroll-m-32`}
  }

  p {
    ${tw`mb-4`}
  }
  a {
    ${tw`no-underline text-primaryBlue dark:text-gray-500`}
  }
  p a {
    ${tw`underline`}
  }
  ol {
    ${tw`list-decimal`}
  }
  ul {
    ${tw`list-disc`}
  }
  ol {
    ${tw`list-decimal`}
  }
  sup {
    ${tw`top-[-1rem]`}
  }
  svg {
    ${tw`fill-current`}
  }
  code {
    ${tw`font-mono break-all`}
  }
  .osano-cm-widget {
    ${tw`hidden! invisible! opacity-0!`}
  }
  table,
  ol,
  ul,
  p,
  button,
  label,
  input,
  select,
  textarea {
    ${tw`lg:text-lg`}
  }
  /* used for pricing cards and cards when whole card is a link */
  .card-link-hover-style {
    ${tw`relative transition-transform duration-300 ease-out md:hover:scale-[1.02] md:before:(content-[''] hover:opacity-30)
          before:(rounded-4xl absolute -z-10 top-0 left-0 h-full w-full shadow-2xl shadow-black opacity-0 md:hover:opacity-30
          transition-opacity duration-[250ms] ease-out)`}
  }
`
